var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationState = function SvgLocationState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.039 20.5V19H6.5v-4.25H4.77v-1.5h1.792q.184-1.836 1.513-3.146a5.36 5.36 0 0 1 3.175-1.542V3.923h6.039v3.423H12.75v1.216q1.846.232 3.175 1.542t1.514 3.146h1.792v1.5H17.5V19h3.46v1.5zM8 19h3.25v-4.25H8zm4.75 0H16v-4.25h-3.25zm-4.658-5.75h7.816a3.62 3.62 0 0 0-1.334-2.335A3.95 3.95 0 0 0 12 10a3.95 3.95 0 0 0-2.574.915 3.62 3.62 0 0 0-1.334 2.335"
  })));
};
export default SvgLocationState;